import { __decorate } from "tslib";
import { LitElement, css, html, property, customElement } from 'lit-element';
import { baseStyles } from './styles';
let CdsGridPlaceholder = class CdsGridPlaceholder extends LitElement {
    constructor() {
        super(...arguments);
        this.slot = 'placeholder';
    }
    static get styles() {
        return [baseStyles, css `
      :host {
        display: contents;
      }

      tr {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        grid-column: 1 / -1;
        color: var(--cds-global-typography-color-500);
      }

      td {
        padding: var(--cds-global-space-5) var(--cds-global-space-6) var(--cds-global-space-5) var(--cds-global-space-6);
      }

      :host([draggable=false]) tr {
        border-top: var(--cds-alias-object-border-width-100) solid var(--cds-alias-object-border-color);
        min-height: var(--cds-global-space-12);
      }

      :host([cds-draggable*=target]) tr::after {
        width: 100%;
        height: var(--cds-global-space-2);
        background: var(--cds-alias-status-alt-tint);
        content: '';
        position: absolute;
        top: 0;
      }
    `];
    }
    render() {
        return html `
      <tr>
        <td tabindex="0" role="cell">
          <slot></slot>
        </td>
      </tr>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true })
], CdsGridPlaceholder.prototype, "slot", void 0);
CdsGridPlaceholder = __decorate([
    customElement('cds-grid-placeholder')
], CdsGridPlaceholder);
export { CdsGridPlaceholder };
//# sourceMappingURL=grid-placeholder.element.js.map